export enum RegistrationRequestStatuses {
    Pending = 1,
    Approved = 2,
    Rejected = 3,
}
